import { render, staticRenderFns } from "./ProjectTodo.vue?vue&type=template&id=64ef5790&scoped=true"
import script from "./ProjectTodo.vue?vue&type=script&lang=js"
export * from "./ProjectTodo.vue?vue&type=script&lang=js"
import style0 from "./ProjectTodo.vue?vue&type=style&index=0&id=64ef5790&prod&lang=css"
import style1 from "./ProjectTodo.vue?vue&type=style&index=1&id=64ef5790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ef5790",
  null
  
)

export default component.exports